import Tools from '@/components/tools/Tools.js'
import { toast, loading } from '@/shared/utils/UIHelper'
import { JWTService } from '@/shared/services/jwt'
// import {VMoney} from 'v-money'

import {en, es, ptBR} from 'vuejs-datepicker/dist/locale'
import Datepicker from 'vuejs-datepicker'

import ActionsForm from '@/shared/mixins/actionsForm'

import RegulationMixin from '@/store/module/regulation/mixin'

import RegulationAutoTypingRepository from '@/shared/http/repositories/regulation/auto/regulationautotyping'
import SinisterHeader from '@/components/regulation/auto/sinisterheader/sinisterheader.vue'
import SinisterTypingForm from './sinistertyping-form'
import SinisterTypingModel from './sinitertyping-model'

export default {
  name: 'SinisterTyping',
  props: [ 'clear' ],
  mixins: [
    ActionsForm,
    RegulationMixin
  ],
  data () {
    return {
      data: SinisterTypingModel,
      form: SinisterTypingForm,
      objRegulationAuto: null,
      model: '',
      modelOptions: [],
      items: [],
      moneyFormat: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 2,
        masked: false
      },
      en: en,
      es: es,
      ptBR: ptBR,
      disableActionDateTyping: false
    }
  },
  components: {
    Datepicker,
    SinisterHeader
  },
  mounted () {
    this.onLoad()
  },
  watch: {
    // TODO RETIRAR APÓS REFACTOR
    clear: function () {
      this.onClear()
    }
  },
  computed: {
    totalBudgeted: function () {
      let value = (
        Number(this.form.bodywork.value) +
        Number(this.form.repair.value) +
        Number(this.form.tapestry.value) +
        Number(this.form.painting.value) +
        Number(this.form.electrical.value) +
        Number(this.form.mechanical.value) +
        Number(this.form.third.value) +
        Number(this.form.withoutSuppliedParts.value) -
        Number(this.form.franchise.value) -
        Number(this.form.carDamage.value)
      )

      return this.formatPrice(value)
    }
  },
  methods: {
    onClearTabs () {
      this.$emit('ClearTabs', this.onClear)
    },
    formatPrice (value) {
      let val = (value / 1).toFixed(2).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },
    onClear () {
      Tools.SetFormDefaultValues(this.form)
    },
    onLoad (obj) {
      this.onClear()
      this.form.surveyDate.value = this.moment().format('YYYY-MM-DD hh:mm:ss')

      if (this.hasRegulation) {
        this.data.regulationAutoID = this.regulation.id
        this.form.regulationAutoID.value = this.regulation.id
        RegulationAutoTypingRepository.GetByRegulationAutoID(this.regulation.id)
          .then((response) => {
            var result = this.onResultObj(response)
            this.form.id.value = '00000000-0000-0000-0000-000000000000'
            if (result !== null) {
              // Object.keys(this.form).forEach((propName) => {
              // this.form[propName].value = result[propName];
              // })
              this.form.id.value = result.id
              this.form.bodywork.value = result.bodywork || 0
              this.form.repair.value = result.repair ? result.repair : 0
              this.form.tapestry.value = result.tapestry ? result.tapestry : 0
              this.form.painting.value = result.painting ? result.painting : 0
              this.form.electrical.value = result.electrical ? result.electrical : 0
              this.form.mechanical.value = result.mechanical ? result.mechanical : 0
              this.form.third.value = result.third ? result.third : 0
              this.form.glassware.value = result.glassware ? result.glassware : 0
              this.form.withSuppliedParts.value = result.withSuppliedParts ? result.withSuppliedParts : 0
              this.form.withoutSuppliedParts.value = result.withoutSuppliedParts ? result.withoutSuppliedParts : 0
              this.form.budgeted.value = result.budgeted ? result.carDamage : 0
              this.form.franchise.value = result.franchise ? result.franchise : 0
              this.form.typeConclusionID.value = result.typeConclusionID
              this.form.lossTypeID.value = result.lossTypeID
              this.form.reasonFrustration.value = result.reasonFrustration
              this.form.engineNumber.value = result.engineNumber
              this.form.carDamage.value = result.carDamage ? result.carDamage : 0
              this.form.description.value = result.description
              // Desabilitado para SurveyDate
              // if (result.surveyDate) {
              this.form.surveyDate.value = result.surveyDate
              //  this.disableActionDateTyping = true
              // } else {
              //  this.disableActionDateTyping = false
              // }
              this.form.comments.value = result.comments
            }
          })
          .catch((err) => {
            this.onException(err)
          })
      }
    },
    onSave () {
      var self = this
      if (this.form.id.value === '') {
        this.form.id.value = '00000000-0000-0000-0000-000000000000'
      }
      this.data.id = this.form.id.value
      this.form.regulationAutoID.value = this.regulation.id
      if (Tools.ValidateForms(this.form, this.data, self)) {
        // Set default data
        this.data.dateUpdate = this.moment().format('YYYY-MM-DD hh:mm:ss')
        this.data.accountIDUpdate = JWTService.GetTokenPayload().AccountID
        if (this.data) {
          this.data.status = 1
          this.onCreate()
        } else {
          toast.error(this.$lang.Common.NoRecordInformed)
        }
      }
    },
    onCreate () {
      loading.push()
      RegulationAutoTypingRepository.Create(this.data)
        .then((response) => {
          var result = this.onResultObj(response)
          if (result !== null) {
            this.onLoad(result.regulationAutoID)
          }
          this.onResult(response, true, true)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onChangeTypeConclusion () {
      this.form.reasonFrustration.required = false
      this.form.lossTypeID.required = false
      this.form.description.required = false

      if (this.form.typeConclusionID.value === 4) {
        this.form.description.required = true
      }

      if (this.form.typeConclusionID.value !== 3 && this.form.typeConclusionID.value !== 6) {
        this.form.lossTypeID.required = true
        return
      }

      if (this.form.typeConclusionID.value === 3 || this.form.typeConclusionID.value === 6) {
        this.form.reasonFrustration.required = true
      }
    },
    onChangeLossType () {
      this.form.engineNumber.required = false

      if (this.form.lossTypeID.value && this.form.lossTypeID.value === 2) {
        this.form.engineNumber.required = true
      }
    },
    onUpdate () {
      loading.push()
      RegulationAutoTypingRepository.Update(this.data)
        .then((response) => {
          this.onResult(response, true, true)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onEdit (obj) {
      loading.push()
      Tools.SetValueInForm(this.form, this.data, obj)
      loading.pop()
    },
    onEditByID (ID) {
      if (ID && ID !== '00000000-0000-0000-0000-000000000000') {
        RegulationAutoTypingRepository.GetByID(ID)
          .then((response) => {
            var obj = this.onResultObj(response)
            if (obj !== null) {
              this.onEdit(obj)
            }
          })
          .catch((err) => {
            this.onException(err)
          })
      } else {
        // this.onClear()
        // this.$emit('Edit', null)
      }
    },
    onEditByRegulationAuto (obj) {
      if (obj && obj !== null) {
        this.objRegulationAuto = obj
        if (obj && obj.id !== '00000000-0000-0000-0000-000000000000') {
          RegulationAutoTypingRepository.GetByRegulationAutoID(obj.id)
            .then((response) => {
              var obj = this.onResultObj(response)
              if (obj !== null) {
                this.onEdit(obj)
              }
            })
            .catch((err) => {
              this.onException(err)
            })
        } else {
          // this.onClear()
          // this.$emit('Edit', null)
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/regulation/auto/typing/sinistertyping.js